import { Game, Guess, Score } from '@/game/model';

export const scoreGuess = (guess: Guess, goal: Guess): Score => {
  if (guess.length !== 4) {
    throw Error('Cannot score an incomplete guess');
  }

  const uncountedGuess = [...guess];

  const black = goal
    .reduce(
      (score, colour, index) => {
        if (guess[index] === colour) {
          uncountedGuess.splice(index, 1, undefined);
          ++score;
        }
        return score;
      },
      0);

  const white = goal
    .reduce(
      (score, colour, index) => {
        if (guess[index] !== colour) {
          const whiteIndex = uncountedGuess.findIndex((guessColour) => colour === guessColour);
          if (whiteIndex >= 0) {
            uncountedGuess.splice(whiteIndex, 1, undefined);
            ++score;
          }
        }
        return score;
      },
      0);

  return { black, white };
};

export const isGameWon = (game: Game) =>
  game.plays.find(({ score }) => score && score.black === 4);

export const isGameLost = (game: Game) => {
  console.log(`isGameLost returning ${(game.plays.length === 10 && game.plays[game.plays.length - 1].score) || game.quit}`);
  return game.plays.length > 10 || game.quit;
};
